import { keyframes } from '@emotion/react';

export const VIEWBOX_SIZE = 44;
export const STROKE_WIDTH = 5;
export const RADIUS = (VIEWBOX_SIZE - STROKE_WIDTH) / 2;
export const CENTER = VIEWBOX_SIZE / 2;
export const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export const rotate = keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' },
});

export const dash = keyframes({
  '0%': {
    strokeDasharray: `1 ${CIRCUMFERENCE}`,
    strokeDashoffset: 0,
  },
  '50%': {
    strokeDasharray: `${CIRCUMFERENCE * 0.75} ${CIRCUMFERENCE}`,
    strokeDashoffset: -CIRCUMFERENCE * 0.12,
  },
  '100%': {
    strokeDasharray: `${CIRCUMFERENCE * 0.75} ${CIRCUMFERENCE}`,
    strokeDashoffset: -CIRCUMFERENCE,
  },
});
